import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from "react";
import { generateOnKeyDownHandler, preventFocusOnMouseDown } from "client/services/accessibility/accessibility-service";
import { withGenericConfig } from "/contexts/generic-config-context";
import { StyledHamburgerMenuComponent } from "./hamburger-menu-component.scss";
class HamburgerMenuComponent extends PureComponent {
    toggleOpenState() {
        const { isOpen } = this.props;
        this.props.changeStateCallback(!isOpen);
    }
    render() {
        const { theme, isInScrollMode, isOpen, translate } = this.props;
        const scrollModeClass = isInScrollMode ? "scroll-mode" : "";
        const openMode = isOpen ? "open" : "";
        return /*#__PURE__*/ _jsxs(StyledHamburgerMenuComponent, {
            className: `hamburger-menu ${theme} ${scrollModeClass} ${openMode}`,
            tabIndex: 0,
            onClick: this.toggleOpenState,
            onKeyDown: this.onKeyDown,
            onMouseDown: preventFocusOnMouseDown,
            "aria-label": isOpen ? translate("header.closeMenu") : translate("header.openMenu"),
            "aria-haspopup": "menu",
            "aria-expanded": isOpen,
            role: "button",
            children: [
                /*#__PURE__*/ _jsx("span", {
                    className: "hamburger-menu-line"
                }),
                /*#__PURE__*/ _jsx("span", {
                    className: "hamburger-menu-line"
                }),
                /*#__PURE__*/ _jsx("span", {
                    className: "hamburger-menu-line"
                }),
                /*#__PURE__*/ _jsx("span", {
                    className: "hamburger-menu-line"
                })
            ]
        });
    }
    constructor(props){
        super(props);
        this.toggleOpenState = this.toggleOpenState.bind(this);
        this.onKeyDown = generateOnKeyDownHandler(this.toggleOpenState);
    }
}
HamburgerMenuComponent.defaultProps = {
    changeStateCallback: ()=>{},
    isInScrollMode: false,
    theme: "",
    isOpen: false
};
export default withGenericConfig(HamburgerMenuComponent);
